export default "__VITE_ASSET__Blow1xFJ__"